import React, { useState, useEffect } from 'react'
import { MiFooter } from '../../components/footer/MiFooter';
import './miEmpresa.css'
import { ContentBodyMiEmpresa } from '../../components/miEmpresa/ContentBodyMiEmpresa';
import HeaderHome from '../../components/headerHome/HeaderHome';

export const MiEmpresa = () => {

  const [MenuLateralAux, setMenuLateralAux] = useState();

  const chageMenuLateralAux = () => {
    setMenuLateralAux(!MenuLateralAux)
  }

  return (
    <div className='UserFeedback'>
      <div className='headerUserFeedback'>
        <HeaderHome
          chageMenuLateralAux={chageMenuLateralAux}
        />
      </div>
      <div className="bodyUserFeedback">
        <ContentBodyMiEmpresa
          MenuLateralAux={MenuLateralAux}
          chageMenuLateralAux={chageMenuLateralAux}
        />
      </div>
      <div className='footerReservarServicio'>
        <MiFooter
        />
      </div>
    </div>
  )
}
